var WDN = WDN || {};

if (typeof WDN.Price === "undefined") {
  WDN.Price = (function () {
    class WDNPrice extends HTMLElement {
      constructor() {
        super();
      }

      // Observer this list of attributes
      static get observedAttributes() {
        return ["data-price-cents", "data-compare-price-cents"];
      }

      // Handles attribute change
      attributeChangedCallback(name, oldValue, newValue) {
        this.normalPrice = parseInt(this.getAttribute("data-price-cents"));
        this.salePrice = parseInt(this.getAttribute("data-compare-price-cents"));
        this.onSaleByDefault = this.normalPrice < this.salePrice;
        this.outputPrices();
      }

      // Helper function to convert money
      money(money_cents) {
        return WDN.Money.format(money_cents);
      }

      // Calculates discount price based on percentage eg. getDiscountedPrice(2000, 20) => 1600
      getDiscountedPrice(price, percentage) {
        return price - (percentage / 100) * price;
      }

      // Returns price container
      getPriceSpan = function () {
        var span = document.createElement("span");
        span.classList.add("pricing-item");
        return span;
      };

      // Returns compare price container
      getComparePriceSpan = function () {
        var span = this.getPriceSpan();
        span.classList.add("pricing-item--compare");
        return span;
      };

      displayPriceWithDiscount() {
        var priceSpan = this.getPriceSpan();
        var discountedNormalPrice = this.getDiscountedPrice(this.normalPrice, this.discountConfig.discountPercentage);

        priceSpan.innerHTML = this.money(discountedNormalPrice).trim();

        // Compare at price
        var comparePriceSpan = this.getComparePriceSpan();
        var comparePrice = this.normalPrice;

        // If compare price is greater than discounted compare price - use intial compare price
        if (this.salePrice > this.normalPrice) {
          comparePrice = this.salePrice;
        }

        comparePriceSpan.innerHTML = this.money(comparePrice).trim();

        // output
        this.appendChild(priceSpan);
        this.appendChild(comparePriceSpan);
        this.classList.add("on-sale");
      }

      displayPriceWithoutDiscount() {
        var priceSpan = this.getPriceSpan();
        priceSpan.innerHTML = this.money(this.normalPrice).trim();

        // Output normal price
        this.appendChild(priceSpan);

        if (!this.onSaleByDefault) {
          this.classList.remove("on-sale");
          return;
        }

        var comparePriceSpan = this.getComparePriceSpan();
        comparePriceSpan.innerHTML = this.money(this.salePrice).trim();

        // Output compare price
        this.appendChild(comparePriceSpan);
      }

      // Main function
      outputPrices() {
        this.innerHTML = ""; // clear current elements
        // Check if discount module active

        if (this.discountToggleActive) {
          this.displayPriceWithDiscount();
          return;
        }

        this.displayPriceWithoutDiscount();
      }

      // Handles discounttoggle:change event on document
      handleDiscountToggleEvent(e) {
        if (e.detail.active === this.discountToggleActive) return;
        this.discountToggleActive = e.detail.active;
        this.outputPrices();
      }

      listenForDiscountToggle() {
        this.handleDiscountToggleEventBound = this.handleDiscountToggleEvent.bind(this);
        document.addEventListener("discounttoggle:change", this.handleDiscountToggleEventBound);
      }

      init() {
        if (this.onSaleByDefault) {
          this.classList.add("on-sale");
        }
        this.outputPrices();

        this.listenForDiscountToggle();
      }

      disconnectedCallback() {
        document.removeEventListener("discounttoggle:change", this.handleDiscountToggleEventBound);
      }

      // Code starts here
      connectedCallback() {
        if (this.hasAttribute("disabled")) return;

        this.discountConfig = WDN.DiscountConfig || {};

        // If Discount enabled
        if (this.discountConfig.enabled) {
          // If localstorage doesn't exists (first time visitor)
          if (localStorage.getItem("discount_toggle_active") === null) {
            // Set state based on theme settings value
            this.discountToggleActive = this.discountConfig.toggleState;
          } else {
            // Set state based on localstorage value
            this.discountToggleActive = localStorage.getItem("discount_toggle_active") === "true";
          }
          // Discount disabled - set false
        } else {
          this.discountToggleActive = false;
        }

        this.normalPrice = parseInt(this.getAttribute("data-price-cents"));
        this.salePrice = parseInt(this.getAttribute("data-compare-price-cents"));
        this.onSaleByDefault = this.normalPrice < this.salePrice;

        this.init();
      }
    }

    customElements.define("wdn-price", WDNPrice);

    return WDNPrice;
  })();
}
